<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("add") }} {{ $t("department") }}</div>
      <button
        @click="gotolistdepartment('/user-management/list-department')"
        class="btn-blue"
      >
        {{ $t("department") }} {{ $tc("list", 2) }}
      </button>
    </div>

    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Departments"
          :key="index"
          v-if="item.fieldname !== 'dept_id'"
          class="col-lg-6 col-xl-4 align-self-center"
        >
          <div v-if="item.fieldname !== 'dept_is_active'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div v-if="item.fieldname === 'dept_is_active'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox mb-0 ml-2"
                v-model="item.fieldvalue"
              />
            </div>
            <p class="error_message"></p>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("save") }} & {{ $t("add") }} {{ $t("more") }}
          </button>
          <button class="btn-black" @click.prevent.stop="resetHandler">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            @click="gotolistdepartment('/user-management/list-department')"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Departments from "@/helper/formJSONMaster/Department";

export default {
  data() {
    return {
      btenable: false,
      Departments: Departments.ms_departments,
      submitted: false,
      Methods: Departments.Methods,
    };
  },
  mounted() {
    this.resetHandler();
  },
  methods: {
    onFocusHandler: function () {
      // this.submitted = false;
    },
    gotolistdepartment(url) {
      this.$router.push({
        path: url,
      });
    },
    resetHandler: function () {
      this.Departments.map((x) => {
        if (x.type === "text" || x.type === "date" || x.type === "number") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    handleSubmit(flag) {
      console.log("call submit :");
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.btenable = true;

          console.log("valid :", valid);
          let body = this.getRequestBody(
            "POST",
            this.Departments,
            this.Methods
          );
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                console.log("here :", data);
                if (flag) {
                  this.$router.push({
                    path: "/user-management/list-department",
                  });
                } else {
                  this.resetHandler();
                }
              } else {
                console.log("show error1 :", data.message);
                this.$toasted.show(data.message);
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>

<style scoped>
.alignment {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/DepartmentComponents/addDepartment.vue